(function () {
  function qs(id){ return document.getElementById(id); }

  const overlay = qs("customizer-overlay");
  const openBtn = qs("open-customizer");
  const closeBtn = qs("close-customizer");

  if (!overlay) return;

  function openDrawer() {
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeDrawer() {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  // expose for later (Step 2 will call these from React if needed)
  window.CustomizerDrawer = { open: openDrawer, close: closeDrawer };

  if (openBtn) openBtn.addEventListener("click", openDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  // click outside to close
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeDrawer();
  });

  // esc to close
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) {
      closeDrawer();
    }
  });
})();
